import { render, staticRenderFns } from "./SimilarCspuModal.vue?vue&type=template&id=91ed861a&scoped=true&"
import script from "./SimilarCspuModal.vue?vue&type=script&lang=js&"
export * from "./SimilarCspuModal.vue?vue&type=script&lang=js&"
import style0 from "./SimilarCspuModal.vue?vue&type=style&index=0&id=91ed861a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ed861a",
  null
  
)

export default component.exports